"use client"

import axios from "axios"
import useRequestIdGenerater from "customhooks"
import { useEffect, useState } from "react"
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp"
import {
    Box,
    Tabs,
    Tab,
    Card,
    CardContent,
    CardActions,
    Typography,
    Button,
    Grid,
    CircularProgress,
    Container,
    Pagination,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Chip,
    Avatar,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@mui/material"
import { Person, Email, Phone, School, CheckCircle, Cancel, VideoCall, Info, Work } from "@mui/icons-material"
import AnimatedLoader from "reuseableTable/AnimatedLoader"
import NoAvailableData from "reuseableTable/NoAvailableData"
import MenteeProfile from "./MenteeProfile"

const MenteeList = () => {
    const [pageData, setPageData] = useState([])
    const [pageCache, setPageCache] = useState({})
    const [currentTab, setCurrentTab] = useState(0)
    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(9)
    const [totalCount, setTotalCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [selectedMentee, setSelectedMentee] = useState(null)
    const [actionType, setActionType] = useState("")
    const [note, setNote] = useState("")
    const [noteError, setNoteError] = useState("")


    const [openMenteeProfile, setOpenMenteeProfile] = useState(false)
    const [menteeResponseData, setMenteeResponseData] = useState([])

    const RequestId = useRequestIdGenerater()
    const { rendomRequestId, generateTimeStamp } = useTimeStamp()

    const tabLabels = ["My Mentees", "Pending", "Rejected"]
    const approvalStatuses = ["Approved", "Pending", "Rejected"]

    const fetchData = async (approvalStatus = approvalStatuses[currentTab], resetPage = false) => {
        setIsLoading(true)
        const currentPage = resetPage ? 0 : page - 1
        const cacheKey = `${approvalStatus}-${currentPage}-${rowsPerPage}`

        try {
            const response = await axios.get(
                `/v1/mentorship/mentee-request?pageSize=${rowsPerPage}&pageNumber=${currentPage}&approvalStatus=${approvalStatus}`,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                        ),
                    },
                },
            )

            const responseData = response?.data?.data?.content || []
            setPageData(responseData)
            setTotalCount(response?.data?.data?.totalElements || 0)

            setPageCache((prev) => ({
                ...prev,
                [cacheKey]: responseData,
            }))

            if (resetPage) {
                setPage(1)
            }
            setIsLoading(false)
            generateTimeStamp()
        } catch (error) {
            setIsLoading(false)
            generateTimeStamp()
            console.error("Failed to fetch data:", error)
        }
    }

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue)
        setPage(1)
        setPageCache({})
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value)
        setPage(1)
        setPageCache({}) // Clear cache when changing rows per page
    }

    const handleApprovalProcss = async (menteeId, approvalStatus, noteText) => {
        const payload = {
            approvalStatus: approvalStatus,
            note: noteText,
        }

        try {
            await axios.post(`/v1/mentorship/mentee-approval-process?menteeId=${menteeId}`, payload, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                    ),
                },
            })

            // Refresh the current page data
            fetchData(approvalStatuses[currentTab])

            // Close dialog and reset state
            setDialogOpen(false)
            setSelectedMentee(null)
            setNote("")
            setNoteError("")
            setActionType("")
        } catch (error) {
            console.error("Failed to process mentee approval:", error)
        }
    }

    const handleApprove = (mentee) => {
        setSelectedMentee(mentee)
        setActionType("approve")
        setDialogOpen(true)
    }

    const handleReject = (mentee) => {
        setSelectedMentee(mentee)
        setActionType("reject")
        setDialogOpen(true)
    }

    const handleDialogClose = () => {
        setDialogOpen(false)
        setSelectedMentee(null)
        setNote("")
        setNoteError("")
        setActionType("")
    }

    const handleDialogSubmit = () => {
        if (actionType === "reject" && !note.trim()) {
            setNoteError("Note is required for rejection")
            return
        }

        setNoteError("")

        const approvalStatus = actionType === "approve" ? "Approved" : "Rejected"
        handleApprovalProcss(selectedMentee, approvalStatus, note.trim())
    }

    const handleNoteChange = (event) => {
        setNote(event.target.value)
        if (noteError) {
            setNoteError("")
        }
    }

    const getMenteeDetails = async (menteeAlumniId) => {
        try {
            const response = await axios.get(`/v1/mentorship/mentee-details?menteeId=${menteeAlumniId}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                    ),
                },
            })
            console.log(response?.data?.data, 'data>>>>>')
            setMenteeResponseData(response?.data?.data)
            generateTimeStamp()
        } catch (error) {
            generateTimeStamp()
            console.error("Failed to fetch data:", error)
        }
    }

    const handleViewProfile = (menteeId) => {
        setOpenMenteeProfile(true)
        getMenteeDetails(menteeId)

    }

    const handleCreateMeeting = () => {
        // Add your create meeting logic here
        console.log("Create meeting clicked")
    }
    const renderMenteeCard = (mentee) => {
        const getStatusColor = (status) => {
            switch (status?.toLowerCase()) {
                case "pending":
                    return "warning"
                case "approved":
                    return "success"
                case "rejected":
                    return "error"
                default:
                    return "default"
            }
        }

        return (
            <Grid item xs={12} sm={6} md={3} key={mentee.id || Math.random()}>
                <Card
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: 6,
                        },
                        borderRadius: 2,
                        border: "1px solid gray",
                    }}
                >
                    <CardContent sx={{ flexGrow: 1, p: 3 }}>
                        {/* Header with Avatar and Name */}
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Avatar
                                alt={mentee?.alumniMemberMini?.name}
                                src={
                                    mentee?.alumniMemberMini?.avatar?.data
                                        ? `data:image/*;base64,${mentee.alumniMemberMini.avatar.data}`
                                        : undefined
                                }
                                sx={{
                                    width: 56,
                                    height: 56,
                                    mr: 2,
                                    bgcolor: "#028943",
                                    fontSize: "1.2rem",
                                    fontWeight: 600,
                                }}
                            >
                                {mentee?.alumniMemberMini?.name
                                    ?.split(" ")
                                    .map((n) => n[0])
                                    .join("") || "AM"}
                            </Avatar>
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography
                                    variant="h6"
                                    component="h3"
                                    sx={{
                                        fontWeight: 600,
                                        lineHeight: 1.2,
                                        mb: 0.5,
                                    }}
                                >
                                    {mentee?.alumniMemberMini?.name || "Anonymous mentee"}
                                </Typography>
                                <Chip
                                    label={mentee.approvalStatus || approvalStatuses[currentTab]}
                                    color={getStatusColor(mentee.approvalStatus || approvalStatuses[currentTab])}
                                    size="small"
                                />
                                <Chip
                                    label={mentee?.alumniMemberMini?.batchTag || "Alumni"}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        borderColor: "#028943",
                                        color: "#028943",
                                        fontSize: "0.75rem",
                                        ml: 1
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Career Status */}
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Work sx={{ color: "text.secondary", mr: 1, fontSize: 20 }} />
                            <Typography variant="body2" color="text.secondary">
                                <strong>Career:</strong> {mentee?.alumniMemberMini?.careerStatus?.replace("_", " ") || "Not specified"}
                            </Typography>
                        </Box>

                        {/* Areas of Interest */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                                Areas of Expertise:
                            </Typography>
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                {mentee?.areaOffers?.length > 0 ? (
                                    <>
                                        {mentee.areaOffers.slice(0, 3).map((area, idx) => (
                                            <Chip
                                                key={idx}
                                                label={area}
                                                size="small"
                                                sx={{
                                                    bgcolor: "#e8f5e8",
                                                    color: "#028943",
                                                    fontSize: "0.75rem",
                                                    "&:hover": {
                                                        bgcolor: "#d4f0d4",
                                                    },
                                                }}
                                            />
                                        ))}
                                        {mentee?.areaOffers?.length > 3 && (
                                            <Chip
                                                label={`+${mentee.areaOffers.length - 3} more`}
                                                size="small"
                                                variant="outlined"
                                                sx={{
                                                    fontSize: "0.75rem",
                                                    borderColor: "#ccc",
                                                    color: "text.secondary",
                                                }}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <Typography variant="caption" color="text.disabled">
                                        No areas specified
                                    </Typography>
                                )}
                            </Box>
                        </Box>

                        {/* menteeship Info */}
                        <Box>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                                Details:
                            </Typography>
                            {mentee?.mentorForReason && (
                                <Typography variant="body2"
                                    color="text.primary"
                                    sx={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        lineHeight: 1.4,
                                    }}>
                                    {mentee?.mentorForReason?.length > 100 ? `${mentee.mentorForReason.substring(0, 100)}...` : mentee.mentorForReason}
                                </Typography>
                            )}
                        </Box>
                        {(currentTab === 0 || currentTab === 2) && (
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                                    Process Note:
                                </Typography>
                                {mentee?.approvalNote ? (
                                    <Typography variant="body2"
                                        color="text.primary"
                                        sx={{
                                            display: "-webkit-box",
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            lineHeight: 1.4,
                                        }}>
                                        {mentee?.approvalNote?.length > 100 ? `${mentee.approvalNote.substring(0, 100)}...` : mentee.approvalNote}
                                    </Typography>
                                ) : (
                                    <Typography>---</Typography>
                                )}
                            </Box>
                        )}

                    </CardContent>
                    <CardActions>
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<Info />}
                            sx={{
                                bgcolor: "#028943",
                                flexGrow: 1,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                "&:hover": {
                                    bgcolor: "#026d35",
                                },
                            }}
                            onClick={() => handleViewProfile(mentee?.id)}>
                            View Details</Button>
                    </CardActions>

                    {currentTab === 1 && (
                        <CardActions sx={{ justifyContent: "space-between", p: 2 }}>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<CheckCircle />}
                                onClick={() => handleApprove(mentee?.id)}
                                size="small"
                            >
                                Approve
                            </Button>
                            <Button
                                variant="outlined"
                                color="error"
                                startIcon={<Cancel />}
                                onClick={() => handleReject(mentee?.id)}
                                size="small"
                            >
                                Reject
                            </Button>
                        </CardActions>
                    )}
                </Card>
            </Grid>
        )
    }


    useEffect(() => {
        const approvalStatus = approvalStatuses[currentTab]
        const cacheKey = `${approvalStatus}-${page - 1}-${rowsPerPage}`

        if (pageCache[cacheKey]) {
            setPageData(pageCache[cacheKey])
        } else {
            fetchData(approvalStatus)
        }
    }, [page, rowsPerPage, currentTab])

    console.log(menteeResponseData, 'length')

    const totalPages = Math.ceil(totalCount / rowsPerPage)

    return (
        <>
            <>
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
                    <Tabs value={currentTab} onChange={handleTabChange}>
                        {tabLabels.map((label, index) => (
                            <Tab key={index} label={label} />
                        ))}
                    </Tabs>
                </Box>

                {/* {currentTab === 0 && pageData.length > 0 && (
                    <Box display="flex" justifyContent="flex-end" mb={3}>
                        <Button
                            color="primary"
                            startIcon={<VideoCall />}
                            onClick={handleCreateMeeting}
                            variant="contained"
                            size="small"
                            sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                px: 3,
                                backgroundColor: '#028943',
                                '&:hover': {
                                    backgroundColor: '#026f35'
                                }
                            }}
                        >
                            Create Meeting
                        </Button>
                    </Box>
                )} */}



                {/* Loading State */}
                {isLoading ? (
                    <Box display="flex" justifyContent="center" py={8}>
                        <AnimatedLoader />
                    </Box>
                ) : (
                    <>
                        {/* Cards Grid */}
                        {pageData.length > 0 ? (
                            <Grid container spacing={3} sx={{ mb: 4 }}>
                                {pageData.map((mentee) => renderMenteeCard(mentee))}
                            </Grid>
                        ) : (
                            <NoAvailableData text={`No ${tabLabels[currentTab].toLowerCase()} Data found.`} />
                        )}

                        {/* Pagination */}
                        {totalPages > 0 && (
                            <Box display="flex" justifyContent="center" mt={4}>
                                <Pagination
                                    count={totalPages}
                                    page={page}
                                    onChange={handleChangePage}
                                    color="primary"
                                    size="large"
                                    showFirstButton
                                    showLastButton
                                />
                            </Box>
                        )}
                    </>
                )}
                <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label={`Note ${actionType === "reject" ? "(Required)" : "(Optional)"}`}
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            value={note}
                            onChange={handleNoteChange}
                            error={!!noteError}
                            helperText={
                                noteError ||
                                (actionType === "approve" ? "Add an optional note for approval" : "Please provide a reason for rejection")
                            }
                            placeholder={
                                actionType === "approve"
                                    ? "Add any additional comments..."
                                    : "Please explain why this mentee request is being rejected..."
                            }
                        />
                    </DialogContent>
                    <DialogActions sx={{ p: 3 }}>
                        <Button onClick={handleDialogClose} color="inherit">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleDialogSubmit}
                            variant="contained"
                            color={actionType === "approve" ? "success" : "error"}
                            startIcon={actionType === "approve" ? <CheckCircle /> : <Cancel />}
                        >
                            {actionType === "approve" ? "Approve" : "Reject"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
            {openMenteeProfile && menteeResponseData?.alumniMember && (
                <Dialog open={openMenteeProfile} onClose={() => setOpenMenteeProfile(false)}>
                    <DialogContent>
                        <MenteeProfile menteeResponseData={menteeResponseData} />
                    </DialogContent>
                </Dialog>
            )}
        </>
    )
}

export default MenteeList
